"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLocationMutationRequest = exports.MAX_LOCATION_RENAME_ITEMS = void 0;
const paths_1 = require("./paths");
const paths_2 = require("./paths");
exports.MAX_LOCATION_RENAME_ITEMS = 400;
function parseLocationMutationRequest(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        throw new Error('Invalid location mutation.');
    const input = value;
    const allowed = [
        'collectionId',
        'locationId',
        'operationId',
        'action',
        ...(input.action === 'update' ? ['name', 'description'] : []),
    ];
    if (Object.keys(input).some((key) => !allowed.includes(key)) ||
        !['update', 'delete'].includes(String(input.action)))
        throw new Error('Invalid location mutation.');
    if (typeof input.collectionId !== 'string' ||
        typeof input.locationId !== 'string' ||
        typeof input.operationId !== 'string')
        throw new Error('Invalid location identity.');
    paths_1.firestorePaths.location(input.collectionId, input.locationId);
    const base = {
        collectionId: input.collectionId,
        locationId: input.locationId,
        operationId: (0, paths_2.requireOperationId)(input.operationId),
    };
    if (input.action === 'delete')
        return { ...base, action: 'delete' };
    if (typeof input.name !== 'string' ||
        !input.name.trim() ||
        input.name.trim().length > 200 ||
        typeof input.description !== 'string' ||
        input.description.length > 2000)
        throw new Error('Invalid location fields.');
    return {
        ...base,
        action: 'update',
        name: input.name.trim(),
        description: input.description.trim(),
    };
}
exports.parseLocationMutationRequest = parseLocationMutationRequest;
